// When running emulators, use these values for all Firebase services
export const LOCALHOST = 'localhost';
export const AUTH_EMULATOR_HOST = 'http://localhost:9099';
export const FIRESTORE_EMULATOR_PORT = '8080';
export const FUNCTIONS_EMULATOR_PORT = '5001';
export const STORAGE_EMULATOR_PORT = '9199';
